import React from 'react';
import { Link } from 'react-router-dom';

import { menuItemsDynamic } from 'components/Menu/MenuItemsDynamic';

import isExternalLink from './isExternalLink';
import generateUUID from 'Utils/generateUUID';

const isDynamic = (type) => {
  return type === 'dynamic';
};

const convertItemsToDefault = (inputArray) => {
  const outputArray = inputArray.map((inputObj) => ({
    label: inputObj.name,
    path: inputObj.id ? `/categories?id=${inputObj.id}` : inputObj.path,
    type: 'services',
  }));
  return outputArray;
};

/* eslint-disable */
export const convertItemsMenu = (
  items=[],
  removeDivider = false,
  type,
  dynamicAction
) => {
  const convertedItems = [];

  if (isDynamic(type)) {
    if (dynamicAction === 'loadCategories') {
      items = convertItemsToDefault(menuItemsDynamic());
      items = items.map(({ path, ...rest }) => {
        const [_, id] = path.split('?');
        const param = id ? id.split('=')[1] : null;
        return {
          ...rest,
          path: param ? `/category/${param}/1` : '/search/1',
        };
      });
    }
  }

  items = items.map(({ path, ...rest }) => {

    let p = path;
    if (/(vendor)+(\?)+/.test(p)) {
      const [_, id] = path.split('?');
      const param = id ? id.split('=')[1] : null;
      if (param)
        p = param ? `/store/${param}/1` : `/search/1`;
    }
    return {
      ...rest,
      path: p,
    };
  });

  items.forEach((item) => {
    if (item.type === 'divider') {
      if (!removeDivider) {
        convertedItems.push({
          label: '',
          key: generateUUID(),
          type: 'divider',
        });
      }
    } else if (item.type === '2FA') {
      convertedItems.push({
        key: generateUUID(),
        type: '2FA',
        label: item.label,
      })
    } else {
      const href = item.path || '#';

      if (isExternalLink(href)) {
        convertedItems.push({
          label: (
              <>
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  data-label={item.label}
                >
                  {item.label}
                </a>
              </>
          ),
          key: generateUUID(),
        });
      } else {
        convertedItems.push({
          label: (
            <Link
              to={href}
              data-label={item.label}
            >
              {item.label}
            </Link>
          ),
          key: generateUUID(),
        });
      }
    }
  });

  return convertedItems;
};
